module.exports = __webpack_public_path__ + "img/associationNodeWhite.4e2704d0.svg";